<div class="audit-log-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_AUDIT_LOG.DESCRIPTION' | translate }}
    </p>

    @if (initialLoadFailed() && loadError(); as error) {
      <tf-settings-load-error
        [title]="error"
        [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
        [details]="loadErrorDetails()"
        [retrying]="isLoading()"
        (retry)="retryLoad()" />
    } @else if (!hasLoadedOnce()) {
      <tf-settings-loading-placeholder [rows]="6" [columns]="columns.length" />
    } @else {
      <tf-settings-audit-log-filters
        [fromDate]="filterValues().fromDate"
        [toDate]="filterValues().toDate"
        [eventType]="filterValues().eventType"
        [scopeType]="filterValues().scopeType"
        [scopeId]="filterValues().scopeId"
        [actorId]="filterValues().actorId"
        [hasActiveFilters]="hasActiveFilters()"
        [isLoading]="isLoading()"
        (filterApplied)="onFilterApplied($event)"
        (filterCleared)="onFilterCleared()"
        (reloadAuditLogs)="reloadAuditLogs()" />

      <tf-settings-inline-message
        [message]="actionError()"
        messageId="audit-log-load-error"
        (dismissed)="clearActionError()" />

      <tf-data-table
        [columns]="columns"
        [value]="auditLogs()"
        [loading]="false"
        [paginator]="true"
        [rows]="50"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        [sortField]="sortField() ?? 'original_event_time'"
        [sortOrder]="sortOrder()"
        [currentPageReportTemplate]="'SETTINGS_AUDIT_LOG.PAGINATION_MESSAGE' | translate"
        styleClass="p-datatable-sm"
        emptyMessageKey="SETTINGS_AUDIT_LOG.NO_AUDIT_LOGS_FOUND"
        (sorted)="onSort($event)"
        (paged)="onPageChange($event)">
        <ng-template tfColumnDef="eventType" let-row let-value="value">
          <span [class]="'scope-badge scope-' + row.eventType.toLowerCase()">
            {{ row.eventType }}
          </span>
        </ng-template>
        <ng-template xyzSharedColumnDef="data" let-row>
          @if (dataEntries(row.data); as entries) {
            @if (entries.length > 0) {
              <ul class="audit-log-data">
                @for (entry of entries; track entry.key) {
                  <li class="audit-log-data__item">
                    <span class="audit-log-data__key">{{ entry.key }}:</span>
                    <span class="audit-log-data__value">{{ entry.value }}</span>
                  </li>
                }
              </ul>
            }
          }
        </ng-template>
      </tf-data-table>
    }
  </div>
</div>
